<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--    조사개요-->

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot" /> 조사개요</h5>
      <div class="writeGridContainer mt-4">
        <div>
          <div>작업공정명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_1 }} </span>
          <ml-input v-else v-model="form.inputA_1" :readonly="board.readonly" />
        </div>
        <div>
          <div>작업명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputA_2 }} </span>
          <ml-input v-else v-model="form.inputA_2" :readonly="board.readonly" />
        </div>
        <div>
          <div>예비조사일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <date-selector v-else v-model="form.inputA_3" :readonly="board.readonly" />
        </div>
        <div>
          <div>측정일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>
          <date-selector v-else v-model="form.inputA_4" :readonly="board.readonly" />
        </div>
        <div>
          <div>재해형태(필수)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <disaster-class-selector v-else v-model="form.inputA_5" :readonly="board.readonly" />
        </div>
        <div>
          <div>작업환경측정<br />기관명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_6 }}</p>
          <ml-input v-else v-model="form.inputA_6" :readonly="board.readonly" />
        </div>
        <div>
          <div>측정 결과</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_7 }}</p>
          <div v-else>
            <vs-radio v-model="form.inputA_7" :disabled="board.readonly" vs-value="적합" vs-name="측정결과" class="mr-4">적합</vs-radio>
            <vs-radio v-model="form.inputA_7" :disabled="board.readonly" vs-value="부적합" vs-name="측정결과" class="mr-4">부적합</vs-radio>
          </div>
        </div>
        <div>
          <div>근로자 대표<br />참석 여부</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_8 }}</p>
          <div v-else>
            <vs-radio v-model="form.inputA_8" :disabled="board.readonly" vs-value="참석" vs-name="참석여부" class="mr-4">참석</vs-radio>
            <vs-radio v-model="form.inputA_8" :disabled="board.readonly" vs-value="미참석" vs-name="참석여부" class="mr-4">미참석</vs-radio>
          </div>
        </div>
        <div>
          <div>작업환경측정 결과 근로자 공지 여부</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_9 }}</p>
          <div v-else>
            <vs-radio v-model="form.inputA_9" :disabled="board.readonly" vs-value="공지" vs-name="공지여부" class="mr-4">공지</vs-radio>
            <vs-radio v-model="form.inputA_9" :disabled="board.readonly" vs-value="비공지" vs-name="공지여부" class="mr-4">비공지</vs-radio>
          </div>
        </div>
      </div>
    </div>

    <!--    작업환경측정 대상 공정 및 유해인자-->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="작업환경측정 대상 공정 및 유해인자"
      :tableData="[
        { id: 'input1', title: '연번', type: 'no', placeholder: '입력', width: '50px' },
        { id: 'input2', title: '측정대상공정', type: 'text', placeholder: '입력' },
        { id: 'input3', title: '측정대상 유해인자', type: 'text', placeholder: '입력' },
        { id: 'input4', title: '유해인자 발생주기', type: 'text', placeholder: '입력' },
        { id: 'input5', title: '근로자 수', type: 'number', placeholder: '입력' },
        { id: 'input6', title: '작업시간', type: 'number', placeholder: '입력' },
        { id: 'input7', title: '분석방법', type: 'text', placeholder: '입력' },
        { id: 'input8', title: '시료채취 수', type: 'number', placeholder: '입력' },
      ]"
      v-model="form.inputCList"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploader from "@/components/FileUploader";
import TableInspectEp from "@/components/TableInspectCustomEp";
import TableEtcCheck from "@/components/TableEtcCheck";
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    DisasterClassSelector,
    DateSelector,
    TableEtcCheck,
    TableInspectEp,
    FileUploader,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;

        value.summary = {
          안전보건점검_사업장명: [],
          안전보건점검_점검표: [],
        };

        value.summary["안전보건점검_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["안전보건점검_점검표"].push({
          ["[공통]안전 순회점검표(현장)"]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  methods: {
    updateEtcListCheck(row, text) {
      this.form.etcList[row].checked = text;
    },
    updateListNote(row, text) {
      this.form.etcList[row].note = text;
    },
    updateList(list) {
      this.form.etcList = list;
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",

        inputCList: [],

        typeTitleList: [],
        photoList: [],
        fileList: [],
        etcList: [],
      },
    };
  },
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
